'use client'; // 确保这是一个客户端 Hook

import { useState, useEffect } from 'react';
import Util from "@/Master/Util";
import EventManager from "@/Fwk/EventManager";
import {masterEvent} from "@/Master/Const/MasterEvent";

const usePageLifecycle = (onEnter?: () => void, onLeave?: () => void) => {
    const [isVisible, setIsVisible] = useState<boolean>(false); // 初始值设为 false

    useEffect(() => {
        // 确保在客户端执行
        if (typeof document !== 'undefined') {

            const onEnterCall = () => {
                setIsVisible(true);
                if (onEnter) onEnter();
                EventManager.dispatchEvent(masterEvent.onEnter);
            }

            const onLeaveCall = () => {
                setIsVisible(false);
                if (onLeave) onLeave();
                EventManager.dispatchEvent(masterEvent.onLeave);
            }

            // 初始化状态
            setIsVisible(document.visibilityState === 'visible');

            const onVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    if (Util.isLog){
                        console.log('[usePageLifecycle]',`document显示`)
                    }
                    onEnterCall();
                } else {
                    if (Util.isLog){
                        console.log('[usePageLifecycle]',`document隐藏`)
                    }
                    onLeaveCall()
                }
            };

            document.addEventListener('visibilitychange', onVisibilityChange);

            const onFocus = () => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onFocus 窗口获得焦点`)
                }
                // 执行用户返回页面时的逻辑
                onEnterCall();
            };

            const onBlur = () => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onBlur 窗口失去焦点`)
                }
                // 执行页面失去焦点时的逻辑
                onLeaveCall();
            };

            window.addEventListener('focus', onFocus);
            window.addEventListener('blur', onBlur);


            const onPageShow = (event:any) => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onPageShow 页面显示`)
                }
                if (event.persisted) {
                    if (Util.isLog){
                        console.log('[usePageLifecycle]',`onPageShow 页面从缓存中恢复`)
                    }
                    // 执行用户返回页面时的逻辑
                    onEnterCall();
                }
            };

            const onPageHide = () => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onPageHide 页面隐藏`)
                }
                // 执行页面隐藏时的逻辑
                onLeaveCall();
            };

            window.addEventListener('pageshow', onPageShow);
            window.addEventListener('pagehide', onPageHide);

            const onOnline = () => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onOnline 网络连接已恢复`)
                }
                // 执行网络恢复后的逻辑，例如同步数据
                onEnterCall();
            };

            const onOffline = () => {
                if (Util.isLog){
                    console.log('[usePageLifecycle]',`onOnline 网络连接已断开`)
                }
                // 执行网络断开后的逻辑，例如显示离线提示
                onLeaveCall();
            };

            window.addEventListener('online', onOnline);
            window.addEventListener('offline', onOffline);

            return () => {
                document.removeEventListener('visibilitychange', onVisibilityChange);

                window.removeEventListener('focus', onFocus);
                window.removeEventListener('blur', onBlur);

                window.removeEventListener('pageshow', onPageShow);
                window.removeEventListener('pagehide', onPageHide);

                window.removeEventListener('online', onOnline);
                window.removeEventListener('offline', onOffline);
            };
        }
    }, [onEnter, onLeave]);

    return isVisible;
};

export default usePageLifecycle;
